import {accordionAnatomy} from '@chakra-ui/anatomy'
import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system'

import colors from '../foundations/colors'
import opacities from '../foundations/opacity'
import shadow from '../foundations/shadow'
import sizes from '../foundations/sizes'
import spacing from '../foundations/space'
import typography from '../foundations/typography'

const {definePartsStyle, defineMultiStyleConfig} =
  createMultiStyleConfigHelpers([...accordionAnatomy.keys, 'icon'])

const baseStyle = definePartsStyle({
  button: {
    alignItems: 'center',
    color: colors.text.primary,
    gap: spacing['5xs'],
    minHeight: sizes.lg,
    paddingX: spacing['3xs'],
    paddingY: spacing['4xs'],
    _active: {
      backgroundColor: colors.background['primary-active'],
    },
    _disabled: {
      opacity: opacities.disabled,
    },
    _focusVisible: {
      shadow: shadow.focus,
    },
    _hover: {
      backgroundColor: colors.background['primary-hover'],
    },
  },
  container: {
    borderColor: colors.border.primary,
  },
  icon: {
    color: colors.icon.primary,
  },
  panel: {
    gap: spacing['5xs'],
    paddingBottom: spacing.xs,
    paddingTop: spacing['5xs'],
    paddingX: spacing['3xs'],
    textColor: colors.text.secondary,
    ...typography.textStyles.body.medium,
  },
})

const fdDarkBase = definePartsStyle({
  button: {
    color: colors.text['contrast-primary'],
    _hover: {
      backgroundColor: colors.background['contrast-active'],
    },
  },
  panel: {
    color: colors.text['contrast-secondary'],
  },
  icon: {
    color: colors.icon.brand,
  },
})

export const accordionTheme = defineMultiStyleConfig({
  baseStyle,
  variants: {fdDarkBase},
})
